import { CheckCircle2, Shield, ArrowRight, Clock, Star } from 'lucide-react';
import ContactForm from '../../components/ContactForm';
import SEO from '../../components/SEO';

export default function LejeDe() {
  const fordele = [
    {
      title: '100% Unverbindlich',
      desc: 'Sie mieten die Maschine für 14 Tage zum ausgiebigen Testen. Es besteht keinerlei Kaufzwang.'
    },
    {
      title: 'Im eigenen Tempo testen',
      desc: 'Lassen Sie Ihr gesamtes Team und alle Einsteller die Maschine in den eigenen Boxen ausprobieren.'
    },
    {
      title: 'Anrechnung beim Kauf',
      desc: 'Entscheiden Sie sich nach der Mietzeit für den Neukauf, rechnen wir die Mietgebühr voll an!'
    }
  ];

  const vilkaar = [
    { label: 'Mietdauer', value: '14 Kalendertage' },
    { label: 'Mietpreis', value: '135,- € zzgl. MwSt.' },
    { label: 'Lieferung & Abholung', value: 'Danshaker organisiert Anlieferung und Rückholung' },
    { label: 'Wichtiger Hinweis', value: 'Mietmaschinen dienen ausschließlich Testzwecken und stehen nicht zum Verkauf' }
  ];

  const tidslinjeTrin = [
    {
      num: '01',
      title: 'Miete anfragen',
      desc: 'Füllen Sie das Formular unten mit Ihren Kontaktdaten und Ihrem Wunschstartdatum aus.'
    },
    {
      num: '02',
      title: 'Absprache & Lieferung',
      desc: 'Wir stimmen den Liefertermin mit Ihnen ab und die Maschine wird direkt zu Ihrem Stall geliefert.'
    },
    {
      num: '03',
      title: '14 Tage Praxistest',
      desc: 'Testen Sie den Danshaker im Alltag und spüren Sie die enorme Entlastung bei jeder Box.'
    },
    {
      num: '04',
      title: 'Entscheidung',
      desc: 'Nach 14 Tagen entscheiden Sie frei: Maschine zurückgeben oder Neugerät mit Anrechnung bestellen.'
    }
  ];

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-950 antialiased">
      <SEO
        title="Danshaker Miete - 14 Tage unverbindlich im Stall testen"
        description="Mieten Sie einen Danshaker für 14 Tage für nur 135 € zzgl. MwSt. Testen Sie die Entmistungs- und Sortiermaschine in Ihrem eigenen Stall. Mietgebühr wird beim Kauf angerechnet."
        path="/de/miete"
        lang="de"
      />

      {/* Top Hero Section */}
      <section className="relative overflow-hidden bg-slate-900 py-20 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(14,103,162,0.2),transparent_50%)]" />
        <div className="mx-auto max-w-7xl px-4 md:px-8 relative z-10">
          <div className="grid gap-12 lg:grid-cols-12 lg:items-center">
            
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/20 border border-[#0E67A2]/40 px-4 py-1.5 text-xs font-black text-sky-400 uppercase tracking-wider">
                <Clock className="h-3.5 w-3.5" aria-hidden="true" />
                <span>14 Tage unverbindlicher Praxistest</span>
              </div>
              <h1 className="text-4xl font-black tracking-tight sm:text-6xl text-white">
                Mieten Sie den Danshaker
              </h1>
              <p className="text-lg sm:text-xl text-slate-300 font-medium leading-relaxed max-w-2xl">
                Testen Sie die Maschine gründlich in Ihrem täglichen Stallablauf vor einer Kaufentscheidung. 100% unverbindlich – und bei anschließendem Kauf wird die Mietgebühr voll gegengerechnet.
              </p>
              
              <div className="flex flex-wrap items-center gap-6 pt-4 text-sm font-bold text-slate-200">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 text-[#0E67A2]" />
                  <span>Mietpreis wird beim Kauf gutgeschrieben</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 text-[#0E67A2]" />
                  <span>Keine Kaufverpflichtung</span>
                </div>
              </div>
            </div>

            {/* Price Badge */}
            <div className="lg:col-span-5 flex justify-center lg:justify-end">
              <div className="rounded-3xl border border-slate-700 bg-slate-800/80 backdrop-blur-md p-8 text-center shadow-2xl max-w-sm w-full">
                <span className="text-xs font-black uppercase tracking-wider text-slate-400">14 Tage Mietpreis</span>
                <div className="text-5xl font-black text-white mt-2 mb-1">
                  135,- €
                </div>
                <span className="text-sm font-semibold text-slate-400">exkl. MwSt. + Kaution</span>
                <div className="mt-6 pt-6 border-t border-slate-700 text-xs text-slate-300 leading-relaxed font-medium">
                  Testen Sie den Danshaker 14 Tage lang im eigenen Stall. Bei anschließendem Neukauf ziehen wir die 135 € direkt vom Rechnungspreis ab.
                </div>
                <a
                  href="#leje-formular"
                  className="mt-6 block w-full rounded-xl bg-[#0E67A2] py-3.5 text-sm font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-md"
                >
                  Miete jetzt anfragen
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <section className="mx-auto max-w-7xl px-4 py-16 md:px-8">
        
        {/* Key Benefits */}
        <div className="grid gap-8 md:grid-cols-3 mb-16">
          {fordele.map((f, idx) => (
            <div key={idx} className="rounded-2xl border-2 border-slate-300 bg-white p-8 shadow-sm">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#0E67A2]/10 text-[#0E67A2]">
                <Star className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-black text-slate-950 mb-2">{f.title}</h3>
              <p className="text-sm text-slate-700 font-semibold leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* 4 Step Timeline */}
        <div className="mb-20">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl font-black text-slate-950">Ablauf der Miete</h2>
            <p className="mt-2 text-slate-700 font-medium">So einfach testen Sie den Danshaker bei sich vor Ort.</p>
          </div>

          <div className="grid gap-6 md:grid-cols-4">
            {tidslinjeTrin.map((trin) => (
              <div key={trin.num} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm relative">
                <span className="text-4xl font-black text-[#0E67A2]/20">{trin.num}</span>
                <h4 className="text-lg font-black text-slate-950 mt-2 mb-2">{trin.title}</h4>
                <p className="text-xs text-slate-700 font-semibold leading-relaxed">{trin.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Two Column Layout: Rental Terms + Form */}
        <div id="leje-formular" className="grid gap-12 lg:grid-cols-12 items-start">
          
          {/* Left: Terms & Info */}
          <div className="lg:col-span-5 space-y-6">
            <div className="rounded-3xl border border-slate-200 bg-white p-6 md:p-8 shadow-xl space-y-6">
              <h3 className="text-2xl font-black text-slate-950">Mietbedingungen</h3>
              
              <dl className="space-y-4">
                {vilkaar.map((item, idx) => (
                  <div key={idx} className="border-b border-slate-100 pb-3">
                    <dt className="text-xs font-bold uppercase tracking-wider text-slate-400">{item.label}</dt>
                    <dd className="text-base font-bold text-slate-900 mt-0.5">{item.value}</dd>
                  </div>
                ))}
              </dl>

              <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4 text-amber-900 text-xs leading-relaxed font-semibold">
                <strong className="block mb-1">Mietmaschinen stehen nicht zum Verkauf:</strong>
                Alle Testmaschinen verbleiben im Mietfuhrpark. Bei einer Kaufentscheidung erhalten Sie eine fabrikneue Maschine frisch aus unserer dänischen Fertigung.
              </div>
            </div>

            <div className="rounded-3xl bg-slate-900 text-white p-6 md:p-8 shadow-xl space-y-4">
              <Shield className="h-8 w-8 text-[#0E67A2]" />
              <h4 className="text-xl font-bold">Haben Sie Fragen zur Miete?</h4>
              <p className="text-sm text-slate-300 font-medium">
                Rufen Sie Rasmus direkt an unter <a href="tel:25303589" className="text-white font-bold underline">+45 2530 3589</a>.
              </p>
            </div>
          </div>

          {/* Right: Booking Form */}
          <div className="lg:col-span-7">
            <div className="rounded-3xl border-2 border-[#0E67A2] bg-white p-6 md:p-10 shadow-2xl">
              <div className="mb-8">
                <span className="text-xs font-black uppercase tracking-wider text-[#0E67A2]">Unverbindliche Anfrage</span>
                <h3 className="text-2xl md:text-3xl font-black text-slate-950 mt-1">Miete für 14 Tage anfragen</h3>
                <p className="mt-2 text-sm text-slate-700 font-medium">
                  Senden Sie uns Ihre Daten und wir setzen uns bezüglich Termin und Anlieferung schnellstmöglich mit Ihnen in Verbindung.
                </p>
              </div>

              <ContactForm defaultService="Danshaker Miete (14 Tage)" buttonText="Mietanfrage senden" lang="de" />
            </div>
          </div>

        </div>

      </section>
    </div>
  );
}
